import Swal from "sweetalert2";
import "./gameAlert.css";

function escapeHtml(str) {
  return String(str ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/**
 * Parchment popup (reference UI #6 / #10): letter1.png sheet, optional image
 * badge on top (e.g. the bulb), title, text and a button.png plank.
 */
export function fireGameAlert({
  icon = "info",
  title = "",
  text = "",
  confirmButtonText = "OK",
  /** Image URL shown above the sheet (e.g. the hint bulb). */
  image = "",
  allowOutsideClick = true,
  allowEscapeKey = true,
  /** Ignore accidental outside/key closes for this many ms after open. */
  dismissGuardMs = 0,
} = {}) {
  const kind = ["success", "error", "info"].includes(icon) ? icon : "info";
  const imageHtml = image
    ? `<img class="game-alert__image" src="${escapeHtml(image)}" alt="" />`
    : "";
  const titleHtml = title
    ? `<h2 class="game-alert__title">${escapeHtml(title)}</h2>`
    : "";
  const textHtml = text ? `<p class="game-alert__text">${escapeHtml(text)}</p>` : "";

  const guardMs = Math.max(0, Number(dismissGuardMs) || 0);
  let guardUntil = 0;

  return Swal.fire({
    html: `<div class="game-alert game-alert--${kind}${image ? " game-alert--has-image" : ""}">
      ${imageHtml}
      <div class="game-alert__sheet">
        ${titleHtml}
        ${textHtml}
        <button type="button" class="pirate-btn game-alert__btn" data-game-alert-close disabled><span>${escapeHtml(
          confirmButtonText
        )}</span></button>
      </div>
    </div>`,
    showConfirmButton: false,
    showCloseButton: false,
    allowOutsideClick: () => {
      if (!allowOutsideClick) return false;
      return Date.now() >= guardUntil;
    },
    allowEscapeKey: () => {
      if (!allowEscapeKey) return false;
      return Date.now() >= guardUntil;
    },
    width: "min(94vw, 40em)",
    heightAuto: true,
    scrollbarPadding: false,
    returnFocus: false,
    customClass: {
      popup: "game-alert-popup",
      htmlContainer: "game-alert-popup__html",
      container: "game-alert-container",
    },
    didOpen: () => {
      guardUntil = Date.now() + guardMs;
      const btn = Swal.getPopup()?.querySelector("[data-game-alert-close]");
      if (!btn) return;

      const enableClose = () => {
        btn.disabled = false;
        btn.addEventListener("click", () => Swal.close(), { once: true });
      };

      if (guardMs > 0) {
        window.setTimeout(enableClose, guardMs);
      } else {
        enableClose();
      }
    },
  });
}
